<template>
  <div class="flex flex-col">
    <!-- Header -->
    <div class="px-4 pt-2 pb-2">
      <p class="text-sm font-medium text-white truncate">
        {{ item.title || item.name }}
      </p>
      <p class="text-xs text-white/60 mt-0.5">
        {{ item.media_type === 'tv' ? 'TV Show' : 'Movie' }}
        <span v-if="releaseYear"> · {{ releaseYear }}</span>
      </p>
    </div>

    <!-- Status section label -->
    <div class="py-2 px-4 text-xs tracking-wider text-gray-500 uppercase">
      Set Status
    </div>

    <!-- Options -->
    <div class="space-y-2 pb-2">
      <OptionItem
        v-for="status in statuses"
        :key="status.value"
        :label="status.label"
        :icon="status.icon"
        :disabled="item.status === status.value"
        @click="handleUpdateStatus(status.value)" />

      <OptionDivider />

      <OptionItem
        label="Remove from watchlist"
        :icon="['fas', 'trash-alt']"
        destructive
        @click="handleRemove" />
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick } from 'vue'
import { OptionItem, OptionDivider } from '@/components/Options'

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  userRole: {
    type: String,
    default: null
  },
  onUpdateStatus: {
    type: Function,
    default: null
  },
  onRemove: {
    type: Function,
    default: null
  }
})

const emit = defineEmits(['close'])

const statuses = [
  { value: 'suggested', label: 'Suggested', icon: ['fas', 'lightbulb'] },
  { value: 'watching', label: 'Watching', icon: ['fas', 'play'] },
  { value: 'watched', label: 'Watched', icon: ['fas', 'check'] }
]

const releaseYear = computed(() => {
  const date = props.item.release_date || props.item.first_air_date
  return date ? date.substring(0, 4) : null
})

const handleUpdateStatus = async (status) => {
  emit('close')
  await nextTick()
  if (props.onUpdateStatus) {
    props.onUpdateStatus({ item: props.item, status })
  }
}

const handleRemove = async () => {
  emit('close')
  await nextTick()
  if (props.onRemove) {
    props.onRemove(props.item)
  }
}
</script>
